"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DecorativeTag", {
  enumerable: true,
  get: function () {
    return _Tag.DecorativeTag;
  }
});
Object.defineProperty(exports, "Tag", {
  enumerable: true,
  get: function () {
    return _Tag.Tag;
  }
});

var _Tag = require("./Tag.styles");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGFnL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IERlY29yYXRpdmVUYWcsIFRhZyB9IGZyb20gJy4vVGFnLnN0eWxlcydcbmV4cG9ydCB0eXBlIHsgRGVjb3JhdGl2ZVRhZ1Byb3BzLCBUYWdDb2xvciwgVGFnUHJvcHMsIFRhZ1NpemVUeXBlIH0gZnJvbSAnLi9UYWcudHlwZXMnXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBIn0=